export default __webpack_public_path__ + "static/header-types-light-2856e2fe9766a36241b2f5e61691df1e.png";